import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["formTemplates", "form", "className", "carouselFullModalClass", "showImages", "expandImages", "setExpandImages", "isLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTheme, createUseStyles, Loader, Icon, Text, Select } from 'hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../../lib/Web5Context";
import UploadImageCarousel from "../../../components/UploadImageCarousel";
import { getImages, deleteImage, getUploadImageUrl, uploadImage } from "../../../lib/services/forms";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FormsModal');
function FormModal(_ref) {
  let {
      formTemplates,
      form,
      className,
      carouselFullModalClass,
      showImages,
      expandImages,
      setExpandImages,
      isLoading
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const classes = useStyles();
  const {
    t,
    bridgeBackend
  } = useWeb5Context();
  const [template, setTemplate] = useState(null);
  const [formTypes, setFormTypes] = useState(null);
  const [images, setImages] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  // Classes
  const rootClassNames = classnames(classes.root, className);
  const carouselFullModalClassNames = classnames(classes.carouselFullModal, carouselFullModalClass);
  const getImagesList = useCallback(() => {
    (form === null || form === void 0 ? void 0 : form.id) && getImages(form.id).then(res => setImages(res.data)).catch(err => {
      console.warn(err);
    });
    !(form !== null && form !== void 0 && form.id) && setImages([]);
  }, [form]);
  const onAddImage = useCallback(droppedImages => {
    const uploadPromises = [];
    const newImages = [];
    droppedImages.forEach(image => {
      let imageId;
      return uploadPromises.push((form === null || form === void 0 ? void 0 : form.id) && getUploadImageUrl(form.id, {
        name: image.name
      }).then(res => {
        imageId = res.data.id;
        return uploadImage(res.data.locator, image);
      }).then(res => {
        if (res.status === 200) {
          newImages.push({
            id: imageId,
            description: image.name,
            strLink: URL.createObjectURL(image)
          });
        } else {
          console.warn('Upload error');
        }
      }).catch(console.warn));
    });
    Promise.all(uploadPromises).then(() => {
      setImages([...images, ...newImages]);
    }).catch(err => {
      console.warn(err);
    });
  }, [form, images]);
  const onDeleteImage = useCallback(index => {
    deleteImage(images[index].id).then(res => {
      if (res.status === 200) {
        const filteredImages = [...images];
        filteredImages.splice(index, 1);
        setImages(filteredImages);
      } else {
        console.warn('Delete image error');
      }
    });
  }, [images]);
  useEffect(() => {
    if (template || !formTemplates) return;
    if (form !== null && form !== void 0 && form.formTemplateId && formTemplates[form.formTemplateId]) {
      return setTemplate(formTemplates[form.formTemplateId]);
    }
    const formTypes = Object.keys(formTemplates).filter(key => formTemplates[key].z_campoextra3 === -1).map(key => _objectSpread(_objectSpread({}, formTemplates[key]), {}, {
      label: formTemplates[key].description,
      value: formTemplates[key].id
    }));
    if (formTypes.length === 1) {
      return setTemplate(formTypes[0]);
    }
    setFormTypes(formTypes);
  }, [form, formTemplates, template]);
  useEffect(() => {
    if (template && !loaded) {
      bridgeBackend.getContext().then(_ref2 => {
        let {
          form
        } = _ref2;
        return bridgeBackend.setContext({
          form: _objectSpread(_objectSpread({}, form), {}, {
            formTemplate: template
          })
        });
      }).then(() => bridgeBackend.loadFragment(template.guid.toUpperCase(), template.url, `fm-fragment-${template.guid.toUpperCase()}`)).then(() => setLoaded(true)).catch(err => {
        var _err$response, _err$response$data;
        if (((_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.code) === 100) {
          console.warn('Invalid fragment GUID');
        }
        console.warn(err);
        setError(true);
      });
    }
  }, [bridgeBackend, form, formTemplates, loaded, template]);
  useEffect(() => {
    if (images === null) {
      getImagesList();
    }
  }, [images, getImagesList]);

  // const onChangeFormType = useCallback((formType) => setTemplate(formType), []);

  if (!form) return null;
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.error
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "warning",
      className: classes.errorIcon,
      color: theme.colors.grey[100]
    }), /*#__PURE__*/React.createElement(Text, {
      className: classes.errorText
    }, t(`error_an_error_occurred`)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassNames
  }, showImages && /*#__PURE__*/React.createElement(UploadImageCarousel, {
    images: images,
    limit: 6,
    onDelete: onDeleteImage,
    onAdd: onAddImage,
    carouselFullModalClass: carouselFullModalClassNames
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, template && /*#__PURE__*/React.createElement("div", {
    id: `fm-fragment-${template.guid.toUpperCase()}`,
    className: classes.fragmentContainer
  }), !template && formTypes && /*#__PURE__*/React.createElement("div", {
    className: classes.templateSelect
  }, /*#__PURE__*/React.createElement(Select, {
    label: t('label_select_form_type'),
    placeholder: t('label_selectone'),
    onChange: setTemplate,
    options: formTypes,
    value: template
  })), isLoading && !formTypes && /*#__PURE__*/React.createElement("div", {
    className: classes.loaderOverlay
  }, /*#__PURE__*/React.createElement(Loader, {
    className: classes.loader
  }))));
}
process.env.NODE_ENV !== "production" ? FormModal.propTypes = {
  form: PropTypes.object,
  showImages: PropTypes.bool,
  expandImages: PropTypes.bool,
  setExpandImages: PropTypes.func,
  isLoading: PropTypes.bool
} : void 0;
export default /*#__PURE__*/memo(FormModal);